import { createContext } from 'react';

export const SkeletonContext = createContext<boolean | null>(null);
